<template>
  <article class="launcher">
    <div class="launcher_banner"></div>
    <div class="launcher_content base_content">
      <div class="launcher_title base_title">Управление лаунчером</div>
      <div class="launcher_content-actions">
        <div class="content_row" v-if="manifestInfo">
          <div class="content_column wide_column">
            <div class="column_title">Информация о файле</div>
            <div class="file_info">
              <div class="file_info-object filepath">
                <div class="file_info-title">Путь:</div>
                <div class="file_info-value">{{ manifestInfo.filepath }}</div>
              </div>
              <div class="file_info-object size">
                <div class="file_info-title">Размер:</div>
                <div class="file_info-value">{{ normalSize(manifestInfo.size, 2) }}</div>
              </div>
              <div class="file_info-object created">
                <div class="file_info-title">Создан:</div>
                <div class="file_info-value">{{ normalTime(manifestInfo.created) }}</div>
              </div>
              <div class="file_info-object modified">
                <div class="file_info-title">Изменен:</div>
                <div class="file_info-value">{{ normalTime(manifestInfo.modified) }}</div>
              </div>
            </div>
            <button type="button" class="btn btn_submit"
              @click="updateManifest" ref="updManButton">Обновить содержимое</button>
          </div>
        </div>
        <div class="content_row">
          <div class="content_column">
            <h3 class="column_title">Добавить ссылку</h3>
            <form class="new_social" @submit.prevent="addLink">
              <input type="text" required autocomplete="off" class="input_wide"
                v-model="newSocial.name" placeholder="Название иконки *">
              <input type="text" required autocomplete="off" class="input_wide"
                v-model="newSocial.url" placeholder="Ссылка *">
              <input type="text" required autocomplete="off" class="input_wide"
                v-model="newSocial.caption" placeholder="Подсказка">
              <button type="submit" class="btn btn_submit">Сохранить</button>
            </form>
          </div>
          <div class="content_column client_update-body">
            <h3 class="column_title">Обновить клиент</h3>
            <form class="update_client" @submit.prevent="updateClient">
              <fileInput text="Выбрать файл" v-model="clientUpdate.archive" />
              <button type="submit" class="btn btn_submit">Загрузить</button>
            </form>
          </div>
          <div class="content_column">
            <h3 class="column_title">Обновить лаунчер</h3>
            <form class="update_launcher" @submit.prevent="updateLauncher">
              <div class="content_row hor_align">
                <fileInput text="Выбрать файл" v-model="launcherUpdate.file" />
                <input type="text" placeholder="Версия*" required autocomplete="off"
                  class="input_wide small_input" v-model="launcherUpdate.version">
              </div>
              <button class="btn btn_submit" type="submit">Загрузить</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>
<script>
import Backend from '../services/backend.service';
import fileInput from '../components/fileInput';

export default {
  name: 'Launcher',
  components: { fileInput },
  data() {
    return {
      backend: new Backend(),
      newSocial: {
        name: null,
        url: null,
        caption: null,
      },
      clientUpdate: {
        archive: null,
      },
      launcherUpdate: {
        file: null,
        version: null,
      },
      manifestInfo: null,
    };
  },
  methods: {
    getManifestInfo() {
      this.backend.get('/updates/manifest')
        .then((resp) => {
          this.manifestInfo = resp;
        })
        .catch(err => console.error(err));
    },
    addLink() {
      this.backend.post('/socials', this.newSocial)
        .then(() => {
          this.$notify({
            status: this.backend.status,
            text: this.backend.msg,
          });
          setTimeout(() => {
            this.newSocial.name = null;
            this.newSocial.url = null;
            this.newSocial.caption = null;
          }, 1500);
        })
        .catch(err => console.error(err));
    },
    updateClient() {
      // const formData = new FormData();
      // formData.append('archive', this.clientUpdate.archive);
      // this.backend.post('/updates/client', formData)
      //   .then((resp) => {
      //     console.log(resp);
      //     this.$notify({
      //       status: this.backend.status,
      //       text: this.backend.msg,
      //     });
      //     setTimeout(() => {
      //       this.clientUpdate.archive = null;
      //     }, 1500);
      //   })
      //   .catch(err => console.error(err));
    },
    updateManifest() {
      const prevText = this.$refs.updManButton.textContent;
      this.$refs.updManButton.textContent = '';
      this.backend.patch('/updates/manifest')
        .then((success) => {
          console.log(success);
          window.location.reload();
        })
        .catch(err => console.error(err))
        .finally(() => {
          this.$refs.updManButton.textContent = prevText;
        });
    },
    normalTime(timestamp) {
      const days = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
      const dt = new Date(timestamp * 1000);
      const date = dt.getDate().toString();
      const day = dt.getDay();
      const year = dt.getFullYear();
      const month = (dt.getMonth() + 1).toString();
      const hours = dt.getHours().toString();
      const minutes = dt.getMinutes().toString();
      const seconds = dt.getSeconds().toString();
      const time = `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
      const dateInfo = `${days[day - 1]} ${date.padStart(2, '0')}.${month.padStart(2, '0')}.${year}`;
      return `${dateInfo} ${time}`;
    },
    normalSize(bytes, decimals = 2) {
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Байт', 'КБайт', 'МБайт', 'ГБайт'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`;
    },
  },
  mounted() {
    this.getManifestInfo();
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";

.launcher{
  &_banner{
    aspect-ratio: 16/4;
    width: 100%;
    background: url('/static/launcher-banner.jpg') no-repeat 50% 7% / cover;
    pointer-events: none;
  }
  &_content{
    &-actions{
      margin-bottom: 40px;
      .content{
        &_row{
          display: flex;
          align-items: center;
          justify-content: space-between;
          .small_input{
            max-width: 100px;
          }
          &.hor_align{
            margin-top: auto;
          }
        }
        &_column{
          &.client_update-body{
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
          &.wide_column{
            width: auto;
          }
          min-height: 210px;
          width: 24%;
          form{
            min-height: 164px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .fileinput{
              margin-top: auto;
            }
            .btn_submit{
              margin-top: auto;
            }
          }
          .column_title{
            color: white;
            font-family: $font;
            font-weight: normal;
            font-size: 24px;
            margin-bottom: 10px;
          }
          .new_social{
            .input_wide{
              margin-bottom: 10px;
            }
          }
        }
      }
      .file_info{
        color: white;
        margin-bottom: 20px;
        &-object {
          font-family: $text-font;
          display: flex;
          align-items: center;
          margin-bottom: 5px;
        }
        &-title{
          min-width: 100px;
        }
        &-value{
          color: $green;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Launcher.vue